<mat-dialog-content>
  <div class="capaloader" *ngIf="loadingService"></div>
  <div
    *ngIf="!error && !loading"
    style="margin-top: 20px !important;"
    class="container-fluid app-endoso py-4"
  >
    <!-- Contenedor APP -->

    <!-- Encabezado y Descripción -->

    <div class="title ">
      <div class="col-12" style="padding-top: 25px;">
        <h3 class="feature-title-endosos">
          SOLICITUD DE AUMENTO O DISMINUCIÓN DE PRIMA EN EXCESO
        </h3>
      </div>
    </div>
    <!-- Encabezado y Descripción FIN -->
    <div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form">
        <div class="col-12" style="padding-top: 15px;">
          <div class="row type-rescue-select py-2 text-center">
            <mat-radio-group
              (change)="change($event.value)"
              labelPosition="after"
              class=""
            >
              <div
                class="custom-control custom-radio radio-button-ib form-group"
              >
                <mat-radio-button [color]="'primary'" value="0" checked
                  >Aumentar prima periódica
                </mat-radio-button>
              </div>
              <div
                class="custom-control custom-radio radio-button-ib form-group"
              >
                <mat-radio-button [color]="'primary'" value="1"
                  >Disminuir prima periódica
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>

        <!--nuevo panel v2-->
        <div style="text-align: center; padding-left: 10%; padding-top: 30px;">
          <div
            style="display: table; width: 550px; font-family: Roboto-Regular;"
          >
            <div style="display: table-row-group; width: 100%; width: 400px;">
              <div
                style=" display: table-row; padding: 10px 30px; text-align: left;"
              >
                <div
                  style="border: 0px solid; display: table-cell; padding: 0px 40px 5px 40px; text-align: center; vertical-align: top;"
                >
                  Tu actual prima periódica total es:
                </div>
                <div
                  style="border: 0px solid; display: table-cell; padding: 0px 0px 5px 0px; text-align: center; vertical-align: top;"
                >
                  Ingresa tu nueva prima periódica total:
                  <svg-icon
                    *ngIf="tipoPrima != 'Aumentar prima en Exceso'"
                    class="icon"
                    app-tooltip="Tu nueva prima no puede ser menor a la actual prima periódica total menos la prima en exceso."
                    position="bottom"
                    src="../../../../../assets/icons/information-right.svg"
                    [svgStyle]="{
                      'width.rem': 0.93,
                      'height.rem': 0.87,
                      position: 'relative',
                      'left.rem': 0.15
                    }"
                  ></svg-icon>
                </div>
              </div>
              <div style=" display: table-row;">
                <div
                  style="border: 0px solid; display: table-cell; padding: 3px 10px 7px 10px; text-align: center; vertical-align: middle;"
                >
                  <strong
                    >UF
                    {{ ValorPrimaPeriodica.toFixed(4).replace('.', ',') }}
                  </strong>
                </div>
                <div
                  style="border: 0px solid; display: table-cell; padding: 3px 30px; text-align: center; vertical-align: middle; width: 150px;"
                >
                  <app-form-input-text
                    [prefix]="'UF'"
                    [maxlength]="6"
                    autocomplete="off"
                    required
                    formControlName="UF"
                    (keyup)="transformValue()"
                    (keypress)="numberOnly($event)"
                    (focusout)="onLostFocusUF()"
                    [messageError]="
                      !form.get('UF').value && pierdeFocoUF
                        ? 'Ingrese un monto válido.'
                        : getErrorMessage(form, 'UF')
                    "
                  >
                  </app-form-input-text>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" py-2">
          <div
            *ngIf="tipoPrima === 'Aumentar prima en Exceso'"
            class="descripcion-page-endosos"
          >
            <p class="descripcion-page-endosos-margen-center">
              Ingresa tus datos de contacto para comunicarnos en caso que sea
              necesario.
            </p>
          </div>
          <div
            *ngIf="tipoPrima != 'Aumentar prima en Exceso'"
            class="descripcion-page-endosos"
          >
            <p class="descripcion-page-endosos-center">
              Esta solicitud está sujeta a evaluación ya que la prima periódica
              debe cumplir un monto mínimo, el que depende de las condiciones
              pactadas en tu póliza.
            </p>
            <p class="descripcion-page-endosos-center">
              Ingresa tus datos de contacto para comunicarnos en caso de que sea
              necesario.
            </p>
          </div>
          <div class="col-12">
            <hr class="linea-espacio" style="margin-top: 10px;" />
          </div>
        </div>
        <div class="form-group col-md-6">
          <div class="pd-lr-15 positionRelative ">
            <app-form-input-text
              [label]="'Correo eletrónico'"
              [placeholder]="'Ej: juanperez@gmail.com'"
              [prefix]="''"
              [maxlength]="120"
              [type]="'text'"
              [typeNumber]="false"
              autocomplete="off"
              [innerValue]="emailDeposito"
              [disabled]="true"
              (lostFocus)="onLostFocus('Email')"
            >
            </app-form-input-text>
            <svg-icon
              *ngIf="mostrarInfo"
              class="icon svgEmail"
              app-tooltip="{{ info }}"
              position="right"
              src="../../assets/icons/information-right-white.svg"
              [svgStyle]="{
                'width.rem': 0.93,
                'height.rem': 0.87,
                position: 'relative',
                'left.rem': 0.15
              }"
            ></svg-icon>
          </div>
        </div>

        <!-- Input Telefono -->
        <div class="form-group col-md-6">
          <div class="pd-lr-15">
            <app-form-input-text
              [label]="'Teléfono de contacto'"
              [placeholder]="'912345678'"
              [prefix]="'+56'"
              [maxlength]="9"
              autocomplete="off"
              [typeNumber]="true"
              required
              formControlName="Telefono"
              [messageError]="
                !form.get('Telefono').value && pierdeFocoTelefono
                  ? 'Ingrese un teléfono válido.'
                  : getErrorMessage(form, 'Telefono')
              "
              (lostFocus)="onLostFocus('Telefono')"
            >
            </app-form-input-text>
          </div>
        </div>

        <!-- Select Selección Tipo Siniestro -->
        <div class="row py-2">
          <app-mini-loader *ngIf="loadingService"></app-mini-loader>
          <app-error *ngIf="errorFormulario"></app-error>
          <app-empty-data-message
            *ngIf="formularioSinProblemas"
            message="Su solicitud ha sido registrada con éxito."
          >
          </app-empty-data-message>
        </div>
        <!-- Select Selección Tipo Siniestro FIN -->

        <!-- FIN CONTAINER -->
        <div class="row py-2">
          <div class="col-sm-12 text-center">
            <!-- (click)="close()" -->
            <button
              style="font-size: 14px !important;"
              mat-flat-button
              type="button"
              class="btn btn-gray"
              (click)="onClose()"
            >
              Cancelar
            </button>
            <button
              mat-flat-button
              color="primary"
              type="submit"
              class="btn"
              style="font-size: 14px !important;"
              name="action"
              [disabled]="
                !form.valid ||
                !form.dirty ||
                form.get('UF').value >= 100 ||
                form.get('UF').value < 1 ||
                !botonSolicitarHabilitado
              "
            >
              Solicitar
            </button>
          </div>
          <!-- <button type="submit">
              Ingresar
            </button> -->
        </div>
      </form>
      <hr />
    </div>
  </div>
  <!-- Contenedor APP FIN -->
</mat-dialog-content>
